import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-quote-details-modal',
  templateUrl: './quote-details-modal.component.html'
})
export class QuoteDetailsModalComponent {
  @Input() sale: any;
  PRODUCTS: any = [];
  DETAILS: any = [];
  skuMap: Record<number, string> = {};
  constructor(public activeModal: NgbActiveModal) { }
  ngOnInit(): void {
    this.listProducts();
  }
  listProducts() {
    // console.log(this.sale);
    this.DETAILS = this.sale.details ?? [];
    this.PRODUCTS = typeof this.sale.sale_details === 'string' ? JSON.parse(this.sale.sale_details) : this.sale.sale_details;
    console.log(this.DETAILS);
    console.log(this.PRODUCTS);
    this.buildSkuMap();
  }

  private buildSkuMap(): void {
    this.skuMap = {};

    if (this.DETAILS.length > 0) {
      this.DETAILS.forEach((item: any) => {
        const id = Number(item?.product?.id);

        if (id) {
          this.skuMap[id] = item?.product?.sku ?? '';
        }
      });
    } else {
      this.PRODUCTS.forEach((item: any) => {
        const id = Number(item?.product_id);

        if (id) {
          this.skuMap[id] = item?.sku ?? '';
        }
      });
    }
    console.warn(this.skuMap)
  }


}
